"use client";

import { createSVGIcon } from "@faire/slate/lib/iconUtils";
import React from "react";

/**
 * @figma designed by Gabe Kelley (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=8944%3A1599))
 * @trackcomponent
 * @lastsynced 2025-07-07T16:20:07.894Z
 */
export const Czechia = createSVGIcon(
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.16016 2.61V14.37H16.8402V2.61H1.16016Z"
      fill="#E31D1C"
    />
    <mask
      id="mask0_8944_1599"
      style={{ maskType: "luminance" }}
      maskUnits="userSpaceOnUse"
      x="1"
      y="2"
      width="16"
      height="13"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.16016 2.61V14.37H16.8402V2.61H1.16016Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_8944_1599)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.16016 1.63V8.49H16.8402V1.63H1.16016Z"
        fill="#F7FCFF"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.16016 2.61V14.37L9.98016 8.49L1.16016 2.61Z"
      fill="#3D58DB"
    />
    <rect x="1" y="2" width="16" height="12" stroke="#757575" />
  </>,
  "Czechia",
  { fill: "none", viewBox: "0 0 18 16" } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
